<template>
  <div class="sd-page">
    <button type="button" class="sd-back" @click="volver">
      <span class="material-symbols-outlined">arrow_back</span> Volver
    </button>

    <header class="sd-page-head">
      <div>
        <p class="sd-eyebrow">Galería</p>
        <h1 class="sd-title">{{ titulo || "Álbum" }}</h1>
        <p v-if="!loading && imagenes.length" class="sd-subtitle">{{ resumen }}</p>
      </div>
      <botones-compartir
        v-if="!loading && imagenes.length"
        compacto
        :titulo="titulo || 'Álbum de fotos'"
        :texto="resumen"
        :ruta="rutaCompartir"
        tipo="album"
        :id="String($route.query.id)"
      />
    </header>

    <div v-if="loading" class="carrete-skeletons">
      <div v-for="n in 8" :key="n" class="sd-skeleton"></div>
    </div>

    <p v-else-if="!imagenes.length" class="sd-empty">
      <span class="material-symbols-outlined">photo_library</span>
      Este álbum todavía no tiene fotos.
    </p>

    <grid-fotos v-else :listaImagenes="imagenes" />
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import GridFotos from "@/components/galeria/GridFotos.vue";
import BotonesCompartir from "@/components/compartir/BotonesCompartir.vue";

export default {
  name: "vistaCarrete",
  components: { GridFotos, BotonesCompartir },
  metaInfo() {
    return {
      title: `${this.$root.constantes.nombre_sitio} - ${this.titulo || "Galería"}`,
      meta: [
        {
          name: "description",
          content: `Imágenes y vídeos de actividades de la ${this.$root.constantes.nombre_sitio}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: `${this.$root.constantes.sitio_web}${this.$route.fullPath}`,
        },
      ],
    };
  },
  data() {
    return {
      titulo: (this.$route.query.title || "").toString().replace(/_/g, " "),
      imagenes: [],
      loading: true,
    };
  },
  computed: {
    rutaCompartir() {
      const q = this.$route.query;
      return `/carrete?id=${q.id}` + (q.title ? `&title=${encodeURIComponent(q.title)}` : "");
    },
    resumen() {
      const videos = this.imagenes.filter((i) => /youtu/.test(i.imagen || "")).length;
      const fotos = this.imagenes.length - videos;
      const partes = [];
      if (fotos) partes.push(`${fotos} foto${fotos === 1 ? "" : "s"}`);
      if (videos) partes.push(`${videos} vídeo${videos === 1 ? "" : "s"}`);
      return partes.join(" · ");
    },
  },
  watch: {
    "$route.query.id"(id) {
      if (id) this.cargar();
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/imagenes/galeriaImagenes?id=${this.$route.query.id}`);
        if (data && data.galerias) {
          this.titulo = data.galerias.titulo || this.titulo;
          this.imagenes = data.galerias.imagenes || [];
        }
        const og = document.querySelector('head meta[property="og:url"]');
        if (og) og.content = document.location.href;
      } catch (e) {
        this.imagenes = [];
      } finally {
        this.loading = false;
      }
    },
    volver() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push({ name: "Multimedia" });
    },
  },
};
</script>

<style scoped>
.carrete-skeletons {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.carrete-skeletons .sd-skeleton {
  aspect-ratio: 4 / 3;
  border-radius: 14px;
}
</style>
